import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import {List, Map} from 'immutable';
import {callTargetedAction} from 'client/framework';
import tooltipActions from 'sg/Tooltip/Tooltip.actions';
import Tooltip from 'sg/Tooltip/Tooltip.react';
import PieChartV2 from 'client/generic/PieChartV2/PieChartV2.react';

const answeredCorrectlyClass = '#88d371';
const answeredIncorrectlyClass = '#de5566';
const notAnsweredClass = '#cdd0d2';

import './assignment-grade-chart.scss';

export default class AssignmentCompletionGradeChart extends React.Component {
  static propTypes = {
    correctAverage: PropTypes.number.isRequired,
    incorrectAverage: PropTypes.number.isRequired,
    notAnsweredAverage: PropTypes.number.isRequired,
    size: PropTypes.number,
    strokeWidth: PropTypes.number
  };

  constructor(props) {
    super(props);

    this.tooltipStoreName = `completion-grade-chart-tooltip-${uuid()}`;

    this.correct = new Map({
      color: answeredCorrectlyClass,
      value: props.correctAverage
    });

    this.incorrect = new Map({
      color: answeredIncorrectlyClass,
      value: props.incorrectAverage
    });

    this.notAnswered = new Map({
      color: notAnsweredClass,
      value: props.notAnsweredAverage
    });
  }

  toggleTooltip = () => {
    callTargetedAction({
      name: tooltipActions.TOGGLE_VISIBILITY,
      targetStore: this.tooltipStoreName
    });
  };

  makeTooltipContents = () => {
    return (
      <dl className='grade-chart-key'>
        <div className='grade-chart-key-entry'>
          <dt className='grade-chart-key-entry__term grade-chart-answered-correctly' />
          <dd className='grade-chart-key-entry__definition'>Answered Correctly {`(${this.props.correctAverage}%)`}</dd>
        </div>
        <div className='grade-chart-key-entry'>
          <dt className='grade-chart-key-entry__term grade-chart-answered-incorrectly' />
          <dd className='grade-chart-key-entry__definition'>Answered Incorrectly {`(${this.props.incorrectAverage}%)`}</dd>
        </div>
        <div className='grade-chart-key-entry'>
          <dt className='grade-chart-key-entry__term grade-chart-not-answered' />
          <dd className='grade-chart-key-entry__definition'>Not Answered {`(${this.props.notAnsweredAverage}%)`}</dd>
        </div>
      </dl>
    );
  };

  render() {
    return (
      <div>
        <div
          onClick={this.toggleTooltip}
          className='grade-chart'
        >
          <PieChartV2
            size={this.props.size || null}
            strokeWidth={this.props.strokeWidth || null}
            data={new List([this.correct, this.incorrect, this.notAnswered])}
          >
            <h2 className='grade-chart__percentage'>{`${this.props.correctAverage}%`}</h2>
          </PieChartV2>
        </div>
        <Tooltip
          className='grade-chart-tooltip'
          position='right'
          color='light'
          storeName={this.tooltipStoreName}
        >
          {this.makeTooltipContents()}
        </Tooltip>
      </div>
    );
  }
}
